//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head() {
    return {
      meta: [
      { hid: 'robots', name: 'robots', content: 'noindex' },
      ]
    }
  },
}
